import { render, staticRenderFns } from "./optionalRelationship.vue?vue&type=template&id=1dff0046&"
import script from "./optionalRelationship.vue?vue&type=script&lang=js&"
export * from "./optionalRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports